import { CommonModule, registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from './../../../shared/shared.module';
import { ListEmployeesComponent } from './components/list-employees/list-employees.component';
import { EmployeeDetailsModalComponent } from './components/employee-details-modal/employee-details-modal.component';
import { EmployeeRoutingModule } from './employee-routing.module';
import { EmployeeComponent } from './employee.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';




const components =
  [
    EmployeeComponent,
    ListEmployeesComponent,
    EmployeeDetailsModalComponent
  ]
@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    EmployeeRoutingModule,
    SharedModule,
    MatMenuModule,
    MatIconModule,
    
  ],
  
  declarations: [
    ...components
  ]
})
export class EmployeeModule { }
